<template>
	<div class="milestones">
		<div v-for="milestone in milestones" class="row">
			<div class="date-col highlight">
				<span class="dot"></span>
				<span class="date-text">{{$t("milestones." + milestone + ".date")}}</span>
				<p class="desc">
					<b>{{$t("milestones." + milestone + ".title")}}</b></br>{{$t("milestones." + milestone + ".desc")}}
				</p>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		data(){
			return {
				milestones:[
				"intro",
				"elte",
				"district",
				"pediatricBeta",
				"pilotRelease",
				"gitr",
				"beSmart",
				"ministry",
				"now"
				]
			}
		}
	}
</script>

<style scoped>
	.milestones{
		margin: 8px;
		border-left: 2px dotted #333;
	}
	.date-col{
		position: relative;
		padding: 0 8px;
	}
	.dot{
		position: absolute;
		top: 17px;
		left: -6px;
		width: 10px;
		height: 10px;
		border-radius: 5px;
		background: #333;
	}
	.date-text{
		font-style: italic;
		border-bottom: 2px dotted #333;
		margin-left: -8px;
		padding-left: 16px;
		line-height: 20px;
		display: inline-block;
	}
	.desc{
		padding: 0 8px;
		line-height: normal;
		font-size: 10pt;
	}
</style>



// WEBPACK FOOTER //
// Milestones.vue?50c26e14